// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1qCC0","amount":"Amount_amount__2IN0x","tip":"Amount_tip__2i9W_","tipHeader":"Amount_tipHeader__1Po6z","tipsWrap":"Amount_tipsWrap__37Vow"};